class ProductFileUpload extends HTMLElement {
  connectedCallback() {
    this.initializeFileUpload();
  }

  disconnectedCallback() {
    this._uploadController?.abort();
  }

  initializeFileUpload() {
    this._uploadController?.abort();
    this._uploadController = new AbortController();
    const listenerOptions = { signal: this._uploadController.signal };
    this.refs = {
      fileInput: this.querySelector('input[type="file"]'),
      fileName: this.querySelector('[ref="fileName"]'),
      errorMessage: this.querySelector('[ref="errorMessage"]'),
      dropzone: this.querySelector('.file-upload-dropzone')
    };
    this._pickLock = false;
    const fileName = this.refs.fileName;
    if (fileName && !fileName.dataset.emptyText) fileName.dataset.emptyText = fileName.textContent;

    this.addEventListener('click', (event) => {
      const target = event.composedPath()[0];
      if (target?.getAttribute?.('on:click') === '/triggerUpload') {
        event.preventDefault();
        event.stopPropagation();
        if (this._pickLock) return;
        this._pickLock = true;
        this.refs.fileInput?.click();
        setTimeout(() => { this._pickLock = false; }, 700);
      }
    }, listenerOptions);

    if (this.refs.dropzone) {
      const dz = this.refs.dropzone;
      const openPicker = (e) => {
        e?.preventDefault();
        if (this._pickLock) return;
        this._pickLock = true;
        // Temporarily disable click interactions to avoid double-open
        dz.style.pointerEvents = 'none';
        dz.classList.add('is-click-disabled');
        this.refs.fileInput?.click();
        setTimeout(() => {
          this._pickLock = false;
          dz.style.pointerEvents = 'auto';
          dz.classList.remove('is-click-disabled');
        }, 700);
      };
      dz.addEventListener('dragover', (e) => { e.preventDefault(); dz.classList.add('is-dragover'); }, listenerOptions);
      dz.addEventListener('dragleave', () => dz.classList.remove('is-dragover'), listenerOptions);
      dz.addEventListener('drop', (e) => {
        e.preventDefault(); dz.classList.remove('is-dragover');
        const dt = e.dataTransfer; if (!dt || !dt.files?.length) return;
        const data = new DataTransfer();
        Array.from(dt.files).forEach(f => data.items.add(f));
        if (this.refs.fileInput) { this.refs.fileInput.files = data.files; this.refs.fileInput.dispatchEvent(new Event('change', { bubbles: true })); }
      }, listenerOptions);
    }

    this.refs.fileInput?.addEventListener('change', (event) => {
      this._pickLock = false;
      const files = event.target.files || [];
      const acceptRaw = this.refs.fileInput?.getAttribute('accept') || '';
      const allow = acceptRaw.split(',').map(s => s.trim()).filter(Boolean);
      const isAllowed = (file) => {
        if (allow.length === 0) return true;
        return allow.some(rule => {
          if (rule.startsWith('.')) return file.name.toLowerCase().endsWith(rule.toLowerCase());
          // MIME pattern
          const [type, subtype] = (rule || '').toLowerCase().split('/');
          if (!type || !subtype || !file.type) return false;
          const [ft, fs] = file.type.toLowerCase().split('/');
          return (type === '*' || type === ft) && (subtype === '*' || subtype === fs);
        });
      };
      if (files.length && !Array.from(files).every(isAllowed)){
        // Show error and reset input
        if (this.refs.errorMessage){
          this.refs.errorMessage.textContent = `Invalid file type. Accepted: ${acceptRaw || 'any'}`;
          this.refs.errorMessage.hidden = false;
        }
        // Clear selection
        this.refs.fileInput.value = '';
        if (this.refs.fileName){
          const hint = this.refs.fileName?.dataset.emptyText || 'No file chosen';
          const isDropzone = !!this.querySelector('.file-upload-dropzone');
          this.refs.fileName.textContent = isDropzone ? (this.refs.fileName.dataset.emptyText || 'Click to upload or drag and drop') : hint;
        }
        // Stop any default click reopening behavior by focusing wrapper
        this.focus?.();
        return;
      } else {
        if (this.refs.errorMessage) this.refs.errorMessage.hidden = files.length > 0;
      }
      let text = this.refs.fileName?.dataset.emptyText || 'No file chosen';
      if (files.length === 1) text = files[0].name;
      else if (files.length > 1) text = files.length + ' files';
      if (this.refs.fileName) this.refs.fileName.textContent = text;
    }, listenerOptions);

    const selectedFiles = this.refs.fileInput?.files;
    if (this.refs.fileName && selectedFiles?.length) {
      this.refs.fileName.textContent = selectedFiles.length === 1 ? selectedFiles[0].name : selectedFiles.length + ' files';
    }
  }
}

if (!customElements.get('product-file-upload')) {
  customElements.define('product-file-upload', ProductFileUpload);
}
